import React from 'react';
export function ToolbarGroup(_a) {
    var children = _a.children;
    return React.createElement("div", { className: "toolbar-button-group" }, children);
}
//# sourceMappingURL=ToolbarGroup.js.map